import { TreeNode } from '../../hooks/stores/launcherElementsStore';

interface MarkedTreeNode extends TreeNode {
  marked: boolean;
}

export const moveNodesToParentByID = ({
  tree,
  nodeIDs,
  parentID,
  index,
}: {
  tree: TreeNode[];
  nodeIDs: string[];
  parentID?: string;
  index?: number;
}): TreeNode[] => {
  const nodesToMove: TreeNode[] = [];
  const parent = parentID && findNodeByIDRecursively(tree, parentID);

  nodeIDs.forEach((nodeID) => {
    const node = findNodeByIDRecursively(tree, nodeID);
    if (node) {
      nodesToMove.push({ ...node } as TreeNode);
      (node as MarkedTreeNode).marked = true;
    }
  });

  const targetArr = parent ? parent?.children || tree : tree;
  if (index === undefined) index = targetArr?.length || 0;

  targetArr.splice(index, 0, ...nodesToMove);

  tree = removeMarkedNodesRecursively(tree) || tree;

  return tree;
};

// ----------------------------------------------------------

const findNodeByIDRecursively = (treeNodes: TreeNode[], idToFind: string): TreeNode | undefined => {
  for (const treeNode of treeNodes) {
    if (treeNode.id === idToFind) {
      return treeNode;
    }

    if (treeNode.children) {
      const result = findNodeByIDRecursively(treeNode.children, idToFind);
      if (result) {
        return result;
      }
    }
  }

  return undefined;
};

const removeMarkedNodesRecursively = (treeNodes: (TreeNode | MarkedTreeNode)[] | undefined): TreeNode[] | undefined => {
  if (!treeNodes) {
    return undefined;
  }

  return treeNodes.reduce<TreeNode[]>((acc, treeNode) => {
    if (treeNode.marked === true) {
      if (treeNode.children && treeNode.children.length > 0) {
        return acc;
      }
    }

    const updatedChildren = removeMarkedNodesRecursively(treeNode.children);

    if (updatedChildren) {
      treeNode.children = updatedChildren;
    }

    if (treeNode.marked === true && (!treeNode.children || treeNode.children.length === 0)) {
      return acc;
    }

    acc.push(treeNode);
    return acc;
  }, []);
};
